import React from 'react';
import {useAppSelector} from '../../store/hooks';
import {Category} from '../../types/questions';
import PollFinish from './PollFinish';
import {
  CTA,
  Progress,
  styled,
  Text,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import useTrans from '../../hooks/use-trans';
import { CTAWrapper } from '../../styles/global.style';
import { useFeatureServices } from '../../use-feature-services';
import { Language } from '../../types/locale';
// import { Language } from '../../types/locale';

const PollProgressContainer = styled.div`
  margin-bottom: ${(props) => props.theme.size.dynamic0050};
`;

const PollActionContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.theme.size.dynamic0050};
  margin-top: ${(props) => props.theme.size.dynamic0150};
  margin-bottom: ${(props) => props.theme.size.dynamic0100};

  @media screen and (min-width: 480px) {
    flex-direction: row;
  }
`;

const StepContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${(props) => props.theme.size.dynamic0020};
`;

const ProgressContainer = styled.div`
  margin-top: ${props => props.theme.size.dynamic0040};

  div[class^="StyledProgressWrapper"] {
    height: 6px;
    border-radius: 10px;

    progress {
      appearance: none;
    }

    /* Chrome, Safari, Edge */
    progress::-webkit-progress-bar {
      background-color: #eee;
    }

    progress::-webkit-progress-value {
      background-color: rgb(0, 30, 80);
      border-radius: 10px;
    }

    /* Firefox */
    progress::-moz-progress-bar {
      background-color: rgb(0, 30, 80);
      border-radius: 10px;
    }
  }
`;

interface PollProgressInterface {
  category: Category;
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onBack: () => void;
}

const PollProgress: React.FC<PollProgressInterface> = ({
  category,
  currentStep,
  totalSteps,
  onNext,
  onBack,
}) => {

  const { tracking } = useFeatureServices();

  const trans = useTrans();
  const enTrans = useTrans("en" as Language);

  const answers = useAppSelector((state) => state.answers);

  const progressValue = (currentStep + 1) / totalSteps;

  const handleBackClick = () => {
    onBack();

    tracking.track('VWBasic_Button_Click', {
      link: {
        url: window.location.href,
        name: enTrans.pages.poll.back
      }
    });
  };

  const handleNextClick = () => {
    onNext();

    tracking.track('VWBasic_Button_Click', {
      link: {
        url: window.location.href,
        name: enTrans.pages.poll.next
      }
    });
  };

  return (
    <PollProgressContainer>
      <PollActionContainer>
        {currentStep ? (
          <CTAWrapper>
            <CTA
              tag="button"
              emphasis="secondary"
              onClick={handleBackClick}
              aria-label={trans.pages.poll.back}
              type="button"
            >
              {trans.pages.poll.back}
            </CTA>
          </CTAWrapper>
        ) : null}

        {currentStep < totalSteps - 1 ? (
          <CTAWrapper>
            <CTA
              disabled={answers[category] == null}
              tag="button"
              emphasis="primary"
              onClick={handleNextClick}
              aria-label={trans.pages.poll.next}
              type="button"
            >
              {trans.pages.poll.next}
            </CTA>
          </CTAWrapper>
        ) : (
          <PollFinish disabled={answers[category] == null} />
        )}
      </PollActionContainer>
      <ProgressContainer>
        <Progress value={progressValue} />
      </ProgressContainer>
      <StepContainer>
        <Text appearance={TokenTextAppearance.copy100} bold tag={TextTag.span}>
          {currentStep + 1}/{totalSteps}
        </Text>
      </StepContainer>
    </PollProgressContainer>
  );
};

export default PollProgress;
